<template>
    <div class="step-social-services">

        <div class="welcome-wrap">
            <h1 v-if="!fillingMode">Twoje profile<span class="purple-text">.</span></h1>

            <div class="services" v-if="!fillingMode">
                <icon-checkbox
                        v-for="(service, index) in socialServices"
                        v-on:checked="handleSocialPick"
                        :checked="checkedBoxes.indexOf(index) !== -1"
                        :data="service" :index="index" />
            </div>
        </div>

        <social-form
                v-if="ready && fillingMode"
                v-on:cancel-step="cancelStep"
                v-on:go-back="goBack"
                v-on:next-step="nextStep"
                v-model="formData[currentBox]"
                :user="user"
                :data="socialServices[currentBox]"
                :value="formData[currentBox]"
                :index="currentBox" />

        <div class="welcome-wrap" v-if="!fillingMode">
            <div class="info-text">
                <p class="big">Wybierz społeczności</p>
                <p class="small">na których jesteś obecny<br/>i chcesz współpracować z markami.</p>
            </div>

            <div class="navigation">
                <button v-on:click="enableFillingMode" type="button" class="submit-purple-button">Dalej</button>
            </div>

            <floating-navigation>
                <button v-on:click="goBackGlobal" type="button" class="go-back-button"></button>
            </floating-navigation>
        </div>
    </div>
</template>

<script>
    import IconCheckbox from "./elements/IconCheckbox";
    import SocialForm from "./elements/SocialForm";
    import Spacer from "../Spacer";
    import FloatingNavigation from "./elements/floatingNavigation";
    import { instagramOnly } from '../../variables';

    export default {
        name: "step-social-services",
        props: ["socialServices", "submittedData", 'user', 'socialServicesChecked'],
        components: {FloatingNavigation, Spacer, SocialForm, IconCheckbox},
        mounted: function () {
            this.formData = [];
            this.checkedBoxes = this.socialServicesChecked;

            if(this.submittedData) {
                this.formData = this.submittedData;
            }
            else {
                for (let i = 0; i < this.socialServices.length; i++) {
                    this.formData.push(
                        {
                            valid: true,
                            url: "",
                            score: "",
                            isBarter: false,
                            isPaid: false,
                            income: "",
                            id: this.socialServices[i].id
                        }
                    );
                }
            }

            this.ready = true;

            if(instagramOnly) {
                this.checkedBoxes = [0];
                this.currentBox = 0;
                this.fillingMode = true;
            }

        },
        data: function(){
            return {
                currentBox: 0,
                checkedBoxes: [],
                formData: [],
                showErrors: false,
                ready: false,
                fillingMode: false
            }
        },
        methods: {
            goBackGlobal: function () {
                this.$emit('go-back');
            },
            handleClick: function (index) {
                this.showErrors = false;
                this.currentBox = index;
            },
            handleSocialPick: function (data) {

                let index = this.checkedBoxes.indexOf(data);

                if (index === -1) {
                    this.checkedBoxes.push(data);
                }

                if (index > -1) {
                    this.checkedBoxes.splice(index, 1);
                }

                this.checkedBoxes.sort();
            },
            enableFillingMode: function() {
                if(!this.checkedBoxes.length) {
                    this.$notify({
                        group: 'form',
                        type: 'warn',
                        title: 'Wybierz przynajmniej jedną społeczność'
                    });

                    return;
                }

                this.currentBox = this.checkedBoxes[0];
                this.fillingMode = true;
            },
            goBack: function() {
                let index = this.checkedBoxes.indexOf(this.currentBox);

                if(index === 0) {
                    if(!instagramOnly) {
                        this.fillingMode = false;
                    }
                    else {
                        this.goBackGlobal();
                    }
                }
                else if(index > 0) {
                    this.currentBox = this.checkedBoxes[index - 1];
                }
            },
            cancelStep: function() {
                let index = this.checkedBoxes.indexOf(this.currentBox);

                if(index === 0 && this.checkedBoxes.length === 1) {
                    this.fillingMode = false;
                }

                this.formData[this.currentBox] = {
                    valid: true,
                    url: "",
                    score: "",
                    isBarter: false,
                    isPaid: false,
                    income: "",
                    id: this.socialServices[this.currentBox].id
                };

                let nextBox = this.checkedBoxes[index + 1];
                this.checkedBoxes.splice(index, 1);

                if(this.checkedBoxes.length && nextBox) {
                    this.currentBox = nextBox;
                }
                else {
                    if(this.checkedBoxes.length) {
                        this.currentBox = this.checkedBoxes[this.checkedBoxes.length - 1];
                    }
                    else {
                        this.currentBox = 0;
                    }
                    this.fillingMode = false;
                    this.nextStep();
                }
            },
            nextStep: function () {

                let index = this.checkedBoxes.indexOf(this.currentBox);

                if(index === (this.checkedBoxes.length - 1)) {

                    if(!this.checkedBoxes.length) {
                        this.$notify({
                            group: 'form',
                            type: 'warn',
                            title: 'Wybierz przynajmniej jedną społeczność'
                        });

                        this.fillingMode = false;

                        return;
                    }

                    this.$emit('submit-data', {formData: this.formData, checkedBoxes: this.checkedBoxes});
                }
                else {
                    this.currentBox = this.checkedBoxes[index + 1];
                }
            }
        }
    }
</script>

<style scoped lang="scss">


</style>